//! Mappers

//* Ranker
// eslint-disable-next-line import/prefer-default-export
export { default as buildRankerData } from './ranker-data';

//* Idol
export { buildIdolsData, getIdolDto } from './idol-data';
